<script>
	import { formatDate, stringify_array_value, validateEmail } from "@/mixins/methods";
	import { mapState, mapGetters } from "vuex";
	import i18n from "@/i18n";

	export default {
		data() {
			return {
				discountMinDate: "",
				discountRecurrenceType: "1",
				frequencyDurationOptions: [
					{ value: "day", text: "jour" },
					{ value: "week", text: "semaine" },
					{ value: "month", text: "mois" },
					{ value: "trimester", text: "trimestre" },
					{ value: "semester", text: "semestre" },
					{ value: "year", text: "année" }
				],
				savingStatusOptions: [
					{ value: "draft", text: "Brouillon" },
					{ value: "final", text: "Final" }
				],
				contentBackUp: { // the idea is to have a content restore functionnality 
					headers: null,
					table: null
				},
				tag_error_message: "",
				language: "fr",
			};
		},
		computed: {
			...mapState({
				models: state => state.models.models,
				documentId: state => state.app.documentId,
				isRecurringInvoice: state => state.recurring.isRecurringInvoice,
				contactInfos: state => state.contacts.contactInfos,
				recipients: state => state.recurring.recipients, // is an objet with keys : recorded, main, copyBcc, emails 
				organization: state => state.home.admin,
				table: state => state.billing.table,
				headers: state => state.billing.headers,
        currency: state => state.app.app.config.currency
			}),
			...mapGetters(["organization"]),
			enableRecurringDiscount: {
				get() {
					return this.$store.state.recurring.enableRecurringDiscount;
				},
				set(value) {
					this.$store.commit("enableRecurringDiscount", value);
				}
			},
			enableOrdersPlan: {
				get() {
					return this.$store.state.recurring.enableOrdersPlan;
				},
				set(value) {
					this.$store.commit("enableOrdersPlan", value);
				}
			},
			frequencyCount: {
				get() {
					return this.$store.state.recurring.frequencyCount;
				},
				set(value) {
					this.$store.commit("frequencyCount", value);
				}
			},
			frequencyDuration: {
				get() {
					return this.$store.state.recurring.frequencyDuration;
				},
				set(value) {
					this.$store.commit("frequencyDuration", value);
				}
			},
			nextInvoiceAt: {
				get() {
					// get new periods suggestion for this date
					if (this.$store.state.recurring.nextInvoiceAt !== null) {
						this.$nextTick(() => {
							this.$store.dispatch("getPeriods");
						});
					}
					return this.$store.state.recurring.nextInvoiceAt;
				},
				set(value) {
					this.$store.commit("nextInvoiceAt", value);
				}
			},
			endAt: {
				get() {
					return this.$store.state.recurring.endAt;
				},
				set(value) {
					this.$store.commit("endAt", value);
				}
			},
			discount: {
				get() {
					return this.$store.state.recurring.discount;
				},
				set(value) {
					this.$store.commit("discount", value);
				}
			},
			discountMode: {
				get() {
					return this.$store.state.recurring.discountMode;
				},
				set(value) {
					this.$store.commit("discountMode", value);
				}
			},
			discountStartAt: {
				get() {
					return this.$store.state.recurring.discountStartAt;
				},
				set(value) {
					this.$store.commit("discountStartAt", value);
				}
			},
			discountEndAt: {
				get() {
					return this.$store.state.recurring.discountEndAt;
				},
				set(value) {
					this.$store.commit("discountEndAt", value);
				}
			},
			ordersPlan: {
				get() {
					return this.$store.state.recurring.ordersPlan;
				},
				set(value) {
					if (value.model)
						this.$store.commit("ordersPlan", value);
				}
			},
			savingStatus: {
				get() {
					return this.$store.state.recurring.savingStatus;
				},
				set(value) {
					this.$store.commit("savingStatus", value);
				}
			},
			emailInvoice: {
				get() {
					return this.$store.state.recurring.emailInvoice;
				},
				set(value) {
					this.$store.commit("emailInvoice", value);
				}
			},
			notAttachInvoice: {
				get() {
					return this.$store.state.recurring.notAttachInvoice ? 1 : 0;
				},
				set(value) {
					this.$store.commit("notAttachInvoice", parseInt(value));
				}
			},
			_recurringRecipients: {
				get() {
					return this.recipients.emails.slice(0, 5)
				},
				set(newValue) {
					this.$store.commit("updateRecipientProperty", {
						property: "emails",
						value : newValue
					});
				}
			},
			_needCopyBcc: {
				get() {
					return this.recipients.copyBcc
				},
				set(newValue) {
					this.$store.commit("updateRecipientProperty", {
						property: "copyBcc",
						value: newValue
					});
				}
			},
			organizationAdminEmail() { // headquarter first email  who will receive a copy
				if (this.organization?.needEmailBcc) {
					return this.organization.needEmailBcc;
				} else {
					return null;
				}

			},
			contactInfos_is_set() {
				if (!this.contactInfos)
					return 0;

				return Object.keys(this.contactInfos).length;
			},
			recipients_mention() {
				if (this.main_recipient.length)
					return i18n?.t("Également envoyée à (ajoutez ou supprimez des destinataires)") ?? "";

				return i18n?.t("Envoyée à (ajoutez ou supprimez des destinataires)") ?? "";
			},
			main_recipient() {
				return this.contactInfos?.email ?? this.recipients.main;
			},
      discountOptions() {
        return [
          {value: null, text: this.currency},
          {value: "percent", text: "%"}
        ];
      }
		},
		watch: {
			enableOrdersPlan() {
				if (this.enableOrdersPlan) {
					let lastPlan = null;
					// current content backup
					this.contentBackUp.headers = this.headers;
					this.contentBackUp.table = this.table;

					if (this.ordersPlan.length > 0) {
						lastPlan = this.ordersPlan[this.ordersPlan.length - 1];
					}
					
					if (
						this.ordersPlan.length === 0 ||
						(lastPlan && lastPlan?.end_at !== null)
					) {
						if (this.models[0] && this.models[0]?.id) {
							this.ordersPlan.push({
								model: this.models[0]?.id,
								end_at: ""
							});
							// edit 2023-12 : ne pas charger automatiquement le premier model de la liste
							//this.loadModel(this.models[0]?.id);
						} else {
							this.ordersPlan.push({
								model: null,
								end_at: ""
							});
						}
					}
					
					this.billingTableEdition(false);
				} else {
					const _ordersPlan = this.ordersPlan;
					_ordersPlan.splice(0, (this.ordersPlan.length));
					this.ordersPlan = _ordersPlan;

					// restore content & headers
					this.$store.commit("table", this.contentBackUp.table);
					this.$store.commit("headers", this.contentBackUp.headers);
					
					this.billingTableEdition(true);
				}
			},
			discountRecurrenceType() {
				if (this.discountRecurrenceType === "1") {
					this.discountStartAt = null;
					this.discountEndAt = null;
				}
			}
		},
		async created() {
			this.language = i18n.locale;
			const now = new Date();

			this.nextInvoiceAt = formatDate(now, true);
			this.discountMinDate = formatDate(now, true);

			if (this.documentId && this.isRecurringInvoice) {
				await this.$store.dispatch("loadRecurringDocument");
			}

			if (this.discountStartAt) {
				this.discountRecurrenceType = "2";
			}

			/*if (new Date(this.discountEndAt) < new Date()) {
				this.discount = 0;
				this.enableRecurringDiscount = false;
				this.discountStartAt = null;
				this.discountEndAt = null;
			}*/
		},
		methods: {
			addBillingPlan() {
				this.ordersPlan.push({ model: this.models[0]?.id, end_at: "" });
			},
			removeBillingPlan(index) {
				this.ordersPlan.splice(index, 1);
			},
			loadModel(modelId) {
				if (modelId > 0) {
					this.$store.dispatch("loadModel", modelId);
				}
			},
			billingTableEdition(status) {
				this.$emit("event-billingTableEdition", status);
			},
			resetOrderPlans() {
				
				this.enableOrdersPlan = false;
			
			},
			enableOrderPlans() {
				this.enableOrdersPlan = true;

			},
			recipientTagValidator(value) {
				if (stringify_array_value(this._recurringRecipients).length + value.length > 255) {
					this.tag_error_message = i18n.t("Adresses trop longues")
					return false;
				}
				if (!validateEmail(value)) {
					this.tag_error_message = i18n.t("Adresse invalide")
					return false;
				}
				return true;
			},
      formatterConvertNumberToString(value) {
        return this.convertNumberToString(value, 0);
      }
		}
	};
</script>

<template>
	<b-card class="recuring-card">
		<span class="card-subtitle mb-2">
			<b-icon
				icon="arrow-repeat"
				class="font-size-icon"
				aria-hidden="true"
			/>
			{{ $t("Configuration de la facturation automatique") }}
		</span>

		<!-- Recurring bill configuration -->
		<b-row class="recuring-card__section">
			<b-col cols="3">
				<label> {{ $t("Répéter la facture tous les :") }} </label>
				<b-input-group>
					<b-form-input
						v-model="frequencyCount"
						size="sm"
						class="text-right"
					/>

					<label class="sr-only"> {{ $t("Unité de temps") }} </label>
					<b-form-select v-model="frequencyDuration" size="sm">
						<b-select-option
							v-for="item in frequencyDurationOptions"
							:key="item.value"
							v-model="item.value"
						>
							{{ $t(item.text) }}
						</b-select-option>
					</b-form-select>
				</b-input-group>
			</b-col>

			<b-col cols="3">
				<label> {{ $t("Statut de sauvegarde :") }} </label>
				<b-input-group>
					<b-form-select v-model="savingStatus" size="sm">
						<b-select-option
							v-for="item in savingStatusOptions"
							:key="item.value"
							v-model="item.value"
						>
							{{ $t(item.text) }}
						</b-select-option>
					</b-form-select>
				</b-input-group>
			</b-col>

			<b-col cols="3">
				<label> {{ $t("Prochaine facture le :") }} </label>
				<b-form-datepicker
					v-model="nextInvoiceAt"
					size="sm"
					class="
						billing__input
						billing__input--borderBottom
						billing__input--dashed
						billing__input--showAsWritable
						mb-2
					"
					today-button
					:label-today-button="$t('Aujourd’hui')"
					reset-button
					:label-reset-button="$t('Effacer la date')"
					close-button
					:label-close-button="$t('Fermer')"
					:locale="language"
					start-weekday="1"
					:max="endAt"
					:hide-header="true"
					:date-format-options="{
						year: 'numeric',
						month: '2-digit',
						day: '2-digit'
					}"
				/>
			</b-col>

			<b-col cols="3">
				<label> {{ $t("Date de fin (incluse) :") }} </label>
				<b-form-datepicker
					v-model="endAt"
					size="sm"
					class="
						billing__input
						billing__input--borderBottom
						billing__input--dashed
						billing__input--showAsWritable
						mb-2
					"
					today-button
					:label-today-button="$t('Aujourd’hui')"
					reset-button
					:label-reset-button="$t('Effacer la date')"
					close-button
					:label-close-button="$t('Fermer')"
					:locale="language"
					start-weekday="1"
					:min="nextInvoiceAt"
					:hide-header="true"
					:date-format-options="{
						year: 'numeric',
						month: '2-digit',
						day: '2-digit'
					}"
					label-no-date-selected=""
				/>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12">
				<b-form-checkbox v-model="emailInvoice" size="sm" class="mb-2">
					{{ $t("Envoyer la facture par email au client") }}
				</b-form-checkbox>

				<!-- contactInfos.email is empty-->
				<div
					v-show="!contactInfos_is_set"
					class="pl-3 mb-3"
				>
					<b-icon-exclamation-circle-fill font-scale="1.4" style="color:rgb(153, 153, 153);"/>
					<span class="pl-1" style="color:rgb(153, 153, 153);"> {{ $t("Créez ou sélectionnez un client") }} </span>
				</div>
				<!-- recipients container -->
				<div
					v-show="emailInvoice && contactInfos_is_set"
					class="pl-3"
				>
					<!-- main recipient-->
					<div
						v-show="main_recipient.length"
						class="mb-3"
					>
						<b-icon-check font-scale="1.8" />
						{{ $t("Envoyée à {email}", { email: main_recipient }) }}
					</div>

					<div v-show="emailInvoice" class="mb-3 pl-3 pr-4">
						<label for="recipients"><span style="color: rgb(116, 116, 116)">{{ recipients_mention }} </span></label>
						<b-form-tags
							v-model="_recurringRecipients"
							input-id="recipients"
							:placeholder="$t('+ email')"
							:tag-validator="recipientTagValidator"
							add-button-text="Ajouter"
							:limit="5"
							:limit-tags-text="$t('5 destinataires max')"
							:invalid-tag-text="tag_error_message"
						/>
						<b-tooltip
							placement="left"
							target="needCopyBcc"
						>
							{{ $t("Le mail est un duplicata du mail envoyé à votre destinataire") }}
						</b-tooltip>

						<div class="mt-3">
							<span id="needCopyBcc">
								<b-form-checkbox
								v-model="_needCopyBcc"
								value="1"
								unchecked-value="0"
								size="sm"
								class="mb-2"
								>
									{{ organizationAdminEmail ? $t("Recevoir une copie à") + organizationAdminEmail : $t("Recevoir une copie") }}
								</b-form-checkbox>
							</span>
						</div>

						<b-tooltip
							placement="left"
							target="notAttachInvoice"
						>
							<span v-html="$t('Par défaut, sur la facturation automatique, la facture est ajoutée automatiquement en PJ')" />
						</b-tooltip>

						<div class="mt-3">
							<span id="notAttachInvoice">
								<b-form-checkbox
									v-model="notAttachInvoice"
									value="1"
									unchecked-value="0"
									size="sm"
									class="mb-2"
								>
									{{ $t("Ne pas ajouter la facture en pièce jointe") }}
								</b-form-checkbox>
							</span>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>

		<!-- Discount configuration -->
		<b-row v-if="!enableRecurringDiscount">
			<b-col cols="12">
				<b-link @click="enableRecurringDiscount = true">
					<b-icon
						icon="plus-square-fill"
						class="font-size-icon"
						aria-hidden="true"
					/>
					{{ $t("Ajouter une remise") }}
				</b-link>
			</b-col>
		</b-row>
		<b-row v-if="enableRecurringDiscount" class="recuring-card__section">
			<b-col cols="3">
				<label> {{ $t("Remise de :") }} </label>

				<b-input-group>
					<b-form-input
              v-model="discount"
              lazy-formatter
              :formatter="formatterConvertNumberToString"
              class="text-right"
              size="sm"
          />

					<template>
						<b-form-select v-model="discountMode" size="sm">
							<b-select-option
								v-for="item in discountOptions"
								:key="item.value"
								v-model="item.value"
							>
								{{ item.text }}
							</b-select-option>
						</b-form-select>
					</template>
				</b-input-group>
			</b-col>

			<b-col cols="3">
				<label>{{ $t("Remise à effectuer :") }}</label>
				<b-form-radio-group v-model="discountRecurrenceType">
					<b-form-radio value="1"> {{ $t("Une seule fois") }} </b-form-radio>
					<b-form-radio value="2"> {{ $t("Sur une durée") }} </b-form-radio>
				</b-form-radio-group>
			</b-col>

			<div v-if="discountRecurrenceType === '2'">
				<b-col class="dateReccursing" cols="3">
					<label>{{ $t("Date de début :") }}</label>
					<b-form-datepicker
						v-model="discountStartAt"
						size="sm"
						class="
							billing__input
							billing__input--borderBottom
							billing__input--dashed
							billing__input--showAsWritable
							mb-2
						"
						today-button
						:label-today-button="$t('Aujourd’hui')"
						reset-button
						:label-reset-button="$t('Effacer la date')"
						close-button
						:label-close-button="$t('Fermer')"
						:locale="language"
						start-weekday="1"
						:min="discountMinDate"
						:max="discountEndAt"
						:hide-header="true"
						:date-format-options="{
							year: 'numeric',
							month: '2-digit',
							day: '2-digit'
						}"
						label-no-date-selected=""
					/>
				</b-col>
				<b-col class="dateReccursing" cols="3">
					<label>{{ $t("Date de fin (incluse) :") }}</label>
					<b-form-datepicker
						v-model="discountEndAt"
						size="sm"
						class="
							billing__input
							billing__input--borderBottom
							billing__input--dashed
							billing__input--showAsWritable
							mb-2
						"
						today-button
						:label-today-button="$t('Aujourd’hui')"
						reset-button
						:label-reset-button="$t('Effacer la date')"
						close-button
						:label-close-button="$t('Fermer')"
						:locale="language"
						start-weekday="1"
						:min="discountStartAt"
						:max="endAt"
						:hide-header="true"
						:date-format-options="{
							year: 'numeric',
							month: '2-digit',
							day: '2-digit'
						}"
						label-no-date-selected=""
					/>
				</b-col>
			</div>

			<b-col cols="12">
				<b-link @click="enableRecurringDiscount = false">
					<b-icon
						icon="x-square-fill"
						class="font-size-icon"
						aria-hidden="true"
					/>
					<span> {{ $t("Annuler la remise") }} </span>
				</b-link>
			</b-col>
		</b-row>

		<!-- Billing plan -->
		<b-row v-if="!enableOrdersPlan">
			<b-col cols="12">
				<span>
					<b-link @click="enableOrdersPlan = true">
						<b-icon
							icon="plus-square-fill"
							class="font-size-icon"
							aria-hidden="true"
						/>
						{{ $t("Plan de facturation") }}
					</b-link>
					<span
						id="info-plan-order"
						class="h5 mt-4 mb-2 ml-2"
						style="color: #999"
						>
							<b-icon-question-circle-fill />
					</span>
					<b-tooltip
						target="info-plan-order"
						triggers="hover"
					>
						{{ $t("Consiste à paramétrer des modèles (prix) de factures différents qui vont se générer automatiquement selon les périodes (dates de fin) définies.") }}
						<br>
						{{ $t("Aide :") }}
						<a
							href="https://help.sinao.fr/fr/articles/2616507-comment-gerer-des-cas-complexes-de-facturation-automatique"
							target="_blank"
							style="color: var(--white); text-decoration: underline;"
						> {{ $t("ici") }} </a>.
					</b-tooltip>
				</span>
			</b-col>
		</b-row>

		<div v-if="enableOrdersPlan" class="recuring-card__section">
			<b-row
				v-for="(plan, billingIndex) in ordersPlan"
				:key="billingIndex"
			>
				<b-col cols="3">
					<label> {{ $t("Modèle :") }} </label>
					<b-form-select
						v-model="plan.model"
						size="sm"
						style="width: 150px"
						@change="loadModel(plan.model)"
					>
						<b-select-option
							v-for="(model, modelIndex) in models"
							:key="modelIndex"
							v-model="model.id"
							:disabled="model.id === 0"
						>
							{{ model.name }}
						</b-select-option>
					</b-form-select>
				</b-col>

				<b-col cols="3">
					<label> {{ $t("Date de fin (incluse) :") }} </label>
					<b-form-datepicker
						v-model="plan.end_at"
						size="sm"
						class="
							billing__input
							billing__input--borderBottom
							billing__input--dashed
							billing__input--showAsWritable
							mb-2
						"
						today-button
						:label-today-button="$t('Aujourd’hui')"
						reset-button
						:label-reset-button="$t('Effacer la date')"
						close-button
						:label-close-button="$t('Fermer')"
						:locale="language"
						start-weekday="1"
						:min="discountStartAt"
						:hide-header="true"
						:date-format-options="{
							year: 'numeric',
							month: '2-digit',
							day: '2-digit'
						}"
						label-no-date-selected=""
						@input="addBillingPlan"
					/>
				</b-col>

				<b-col v-if="billingIndex > 0">
					<b-icon
						icon="x"
						class="sinao-clickable sinao-section-icon-trash"
						@click="removeBillingPlan(billingIndex)"
					/>
				</b-col>
			</b-row>

			<b-link @click="resetOrderPlans">
				<b-icon
					icon="x-square-fill"
					class="font-size-icon"
					aria-hidden="true"
				/>
				<span> {{ $t("Annuler le plan de facturation") }} </span>
			</b-link>
		</div>
	</b-card>
</template>

<style lang="scss">
	@import "../../scss/variables.scss";

	.recuring-card {
		width: 210mm;
		margin: 3em auto;
		font-size: $font-size-normal;

		.col-6 {
			padding-left: 15px;
			padding-right: 15px;
		}

		&__section {
			padding-top: 1em;
			padding-bottom: 1em;

			&:not(:first-of-type) {
				border-top: $border-color thin solid;
			}
		}

		a:hover {
			text-decoration: none;
			color: var(--link-hover);
		}

		.dateReccursing {
			max-width: 100% !important;
		}
	}
</style>
